/*eslint no-control-regex: "off"*/

import React, { useState, useRef, useCallback, useEffect } from 'react';
import moment from 'moment';
import { Skeleton, Message } from './base';
import routingTable from '../routingTable';
import { getText } from '../i18n/i18next';
import Ajax from '../components/Ajax';
//import { isArray } from 'util';
import { property } from 'lodash';

const { isArray } = Array;

export const DateFormat = "YYYY-MM-DD";
export const DateTimeFormat = "YYYY-MM-DD HH:mm:ss";
export const DateTimeFormat2 = "YYYY-MM-DD HH:mm";
export const DateTimeFormat3 = "YYYY-MM-DD HH:mm:ss.SSS"; //block duplicate
export const TimeFormat = "HH:mm";
export const DateFormat_printing = "YYYY/MM/DD";
export const DateFormat2 = "D-MMM";

const resolveVal = (soSnapshot, dataSnapshot, path) => {
    if (!path) return undefined;
    const parts = path.split('.');
    const pick = (obj) => {
        let cur = obj;
        for (const p of parts) {
            if (cur === null || cur === undefined) return undefined;
            cur = cur[p];
        }
        return cur;
    };
    const fromData = pick(dataSnapshot);
    return fromData !== undefined ? fromData : pick(soSnapshot);
};

export const getMasterPartyDefaultSourceContext = (soSnapshot = {}, dataSnapshot = {}) => {
    const getVal = (path) => resolveVal(soSnapshot, dataSnapshot, path);

    const doc = (getVal('transport_document') || '').toString();
    const fd_locode = (getVal('fd_locode') || '').toString();
    const country = fd_locode ? fd_locode.slice(0, 2) : '';
    const scac = (getVal('sailing_schedule.carrier_scac') || '').toString();
    const office = getVal('handling_office_code') ?? getVal('handling_office_detail.office_code') ?? '';

    const isHouse = ['Original House Bill', 'House Sea Waybill'].includes(doc);
    const isMaster = ['Original Master Bill', 'Direct Master Sea Waybill'].includes(doc);
    const isFCR = doc === 'Forwarder Cargo Receipt';
    const isUS = country === 'US';

    const shipperPartyID = getVal('shipper_party_id');
    const shipperCode = getVal('shipper_party_code');
    const shipperName = getVal('shipper_detail.name');
    const shipperDetail = getVal('shipper_detail');
    const consigneePartyID = getVal('consignee_party_id');
    const consigneeCode = getVal('consignee_party_code');
    const consigneeName = getVal('consignee_detail.name');
    const consigneeDetail = getVal('consignee_detail');
    const releaseAgentPartyID = getVal('release_agent_party_id');

    return { doc, fd_locode, country, scac, office, isHouse, isMaster, isFCR, isUS, shipperPartyID, shipperCode, shipperName, shipperDetail, consigneePartyID, consigneeCode, consigneeName, consigneeDetail, releaseAgentPartyID };
}

export async function buildMasterPartyDefaultTasks(dataSnapshot = {}, ctx = {}, getMasterPartyMetaData = false, refreshMasterShipperParty = true, refreshMasterConsigneeParty = true) {
    const { office, isHouse, isMaster, isFCR, isUS, scac, shipperPartyID, shipperCode, shipperName, shipperDetail, consigneePartyID, consigneeCode, consigneeName, consigneeDetail, releaseAgentPartyID } = ctx;

    const fetchParty = async (partyType, value, search_type, customer_id) => {
        if (value === undefined || value === null || value === '') return undefined;
        try {
            let url = new URL(`${process.env.PUBLIC_URL}/api/v1/Party/${partyType}/${value}`, window.location.href);
            if (search_type) url.searchParams.append('search_type', search_type);
            if (!CheckIsEmptyString(customer_id) && customer_id > 0) url.searchParams.append('customer_id', customer_id);
            const res = await Ajax.get(url.toString());
            return (res?.data && res.data.length > 0) ? res.data[0] : undefined;
        } catch (e) {
            console.error('fetchParty error', e);
            return undefined;
        }
    };

    const buildDetailFromRes = (res, finalName) => ({
        ...res,
        isf_profile_id: 0,
        name: finalName,
        full_name: res.full_name ?? '',
        party_code: res.party_code,
        office_code: res.party_code,
        address1: res.address1,
        address2: res.address2,
        address3: res.address3,
        address4: res.address4,
        city: res.city,
        city_name: res.city_name,
        state: res.state,
        zip: res.zip_postal,
        country: res.country_name,
        country_code: res.country_code,
        country_name: res.country_name,
        tel: res.tel,
        email: res.email,
        eori_no: res.eori_no,
        fax: res.fax,
        master_name: res.full_name ?? '',
        no_edit_name: res.no_edit_name,
        no_edit_address: res.no_edit_address
    });

    const setNotifySameAsConsignee = () => {
        dataSnapshot.master_notify_party_id = dataSnapshot.master_consignee_party_id;
        dataSnapshot.master_notify_code = dataSnapshot.master_consignee_code;
        dataSnapshot.master_notify_name = 'SAME AS CONSIGNEE';
        dataSnapshot.master_notify_detail = Object.assign({}, dataSnapshot.master_consignee_detail, { address1: '', address2: '', address3: '', address4: '', name: 'SAME AS CONSIGNEE' });

        dataSnapshot.master_also_notify_party_id = null;
        dataSnapshot.master_also_notify_code = null;
        dataSnapshot.master_also_notify_name = null;
        dataSnapshot.master_also_notify_detail = null;
    };

    if (isMaster) {
        if (refreshMasterShipperParty) {
            dataSnapshot.master_shipper_party_id = shipperPartyID;
            dataSnapshot.master_shipper_code = shipperCode;
            dataSnapshot.master_shipper_name = shipperName;
        }
        
        if (refreshMasterConsigneeParty) {
            dataSnapshot.master_consignee_party_id = consigneePartyID;
            dataSnapshot.master_consignee_code = consigneeCode;
            dataSnapshot.master_consignee_name = consigneeName;
        }
    }

    if (refreshMasterShipperParty) {
        if (isHouse || isFCR) {
            const mapping = hdOfficeMasterShipperMapping.find(m => m.handling_office_code === office);
            if (mapping?.master_shipper_code) {
                const res = await fetchParty('masterShippers', mapping.master_shipper_code, 'get_master_bl_party_by_code');
                if (res) {
                    const suffix = isUS ? ' AS AGENT OF MCL - MULTI CONTAINER LINE, INC.' : '';
                    const finalName = (res.full_name ?? '') + suffix;
                    dataSnapshot.master_shipper_party_id = res.party_id;
                    dataSnapshot.master_shipper_code = res.party_code;
                    dataSnapshot.master_shipper_name = finalName;
                    dataSnapshot.master_shipper_detail = buildDetailFromRes(res, finalName);
                }
            }
        } else if (isMaster) {
            if (getMasterPartyMetaData && !CheckIsNullOrUndefined(dataSnapshot.master_shipper_party_id) && dataSnapshot.master_shipper_party_id !== shipperPartyID) {
                const res = await fetchParty('masterShippers', dataSnapshot.master_shipper_party_id, 'get_master_bl_party_by_so_party');
                if (res) {
                    dataSnapshot.master_shipper_detail = buildDetailFromRes(res, res.full_name);
                }
            } else if (dataSnapshot.master_shipper_party_id === shipperPartyID) {
                dataSnapshot.master_shipper_detail = shipperDetail;
            }
        }
    }

    if (refreshMasterConsigneeParty) {
        if (isMaster) {
            if (dataSnapshot.master_consignee_party_id === consigneePartyID) {
                dataSnapshot.master_consignee_detail = consigneeDetail;
            } else if (getMasterPartyMetaData && !CheckIsNullOrUndefined(dataSnapshot.master_consignee_party_id)) {
                const res = await fetchParty('masterConsignees', dataSnapshot.master_consignee_party_id, 'get_master_bl_party_by_so_party');
                if (res) {
                    dataSnapshot.master_consignee_detail = buildDetailFromRes(res, res.full_name);
                    setNotifySameAsConsignee();
                }
            }
        }
        else if (isUS && scac === 'EGLV' && isHouse) {
            const res = await fetchParty('masterConsignees', '1MCLCOMIA', 'get_master_bl_party_by_code');
            if (res) {
                dataSnapshot.master_consignee_party_id = res.party_id;
                dataSnapshot.master_consignee_code = res.party_code;
                dataSnapshot.master_consignee_name = res.full_name;
                dataSnapshot.master_consignee_detail = buildDetailFromRes(res, res.full_name);
                setNotifySameAsConsignee();
            }
        }
        else if (isHouse || isFCR) {
            dataSnapshot.master_consignee_party_id = releaseAgentPartyID;
            if (!CheckIsNullOrUndefined(dataSnapshot.master_consignee_party_id)) {
                const res = await fetchParty('masterConsignees', dataSnapshot.master_consignee_party_id, 'get_master_bl_party_by_so_party');
                if (res) {
                    dataSnapshot.master_consignee_code = res.party_code;
                    dataSnapshot.master_consignee_name = res.full_name;
                    dataSnapshot.master_consignee_detail = buildDetailFromRes(res, res.full_name);
                    setNotifySameAsConsignee();
                }
            }
        }
    }

    return dataSnapshot;
}

export const getMasterDetailDefaultSource = (ctx) => {
    const { isHouse, isMaster, isFCR } = ctx;
    const masterDetailDefaultSource = [];

    if (isHouse || isFCR) {
        masterDetailDefaultSource.push('office');
    } else if (isMaster) {
        masterDetailDefaultSource.push('shipper');
    }

    if (isMaster) {
        masterDetailDefaultSource.push('consignee');
    } else if (isHouse || isFCR) {
        masterDetailDefaultSource.push('release_agent');
    }

    return masterDetailDefaultSource;
}

export const hdOfficeMasterShipperMapping = [
    { handling_office_code: 'CAN', master_shipper_code: '1MRFORCAN' },
    { handling_office_code: 'CKG', master_shipper_code: '1MRFORCKG' },
    { handling_office_code: 'DLN', master_shipper_code: '1MRFORDAL' },
    { handling_office_code: 'NIN', master_shipper_code: '1MRFORNIN' },
    { handling_office_code: 'QIN', master_shipper_code: '1MRFORQIN' },
    { handling_office_code: 'SHA', master_shipper_code: '1MRFORSHA' },
    { handling_office_code: 'SZX', master_shipper_code: '1MRCNCSZX' },
    { handling_office_code: 'TJN', master_shipper_code: '1MRFORTJN' },
    { handling_office_code: 'WUH', master_shipper_code: '1MRFORSHA' },
    { handling_office_code: 'XIM', master_shipper_code: '1MRFORXIM' },
    { handling_office_code: 'JKK', master_shipper_code: '1MRFORJKT' },
    { handling_office_code: 'SRG', master_shipper_code: '1MRFIDSRG' },
    { handling_office_code: 'SUB', master_shipper_code: '1PTSPESUB' },
    { handling_office_code: 'HKG', master_shipper_code: '1MRSPEHKG' },
    { handling_office_code: 'JHB', master_shipper_code: '1MRFORJHB' },
    { handling_office_code: 'KUL', master_shipper_code: '1MRFORKUL' },
    { handling_office_code: 'SIN', master_shipper_code: '1MRSPESIN' },
    { handling_office_code: 'TWN', master_shipper_code: '1MRTAIPEI' },
    { handling_office_code: 'BKK', master_shipper_code: '1MRSPEBKK' },
    { handling_office_code: 'SGN', master_shipper_code: '1MRFORVIC' },
    { handling_office_code: 'HA9', master_shipper_code: '1MRFWDHAN' },
    { handling_office_code: 'DA2', master_shipper_code: '1PLNFSDAC' },
    { handling_office_code: 'TYO', master_shipper_code: '1AOTJNTYO' },
    { handling_office_code: 'PN1', master_shipper_code: '1SRVCFPNH' },
    { handling_office_code: 'SEL', master_shipper_code: '1HAEYGJCN' },
    { handling_office_code: 'COL', master_shipper_code: '1MCSLOCMB' },
    { handling_office_code: 'RG1', master_shipper_code: '1GRTFORGN' },
    { handling_office_code: 'CEB', master_shipper_code: '1EAGLECEB' },
    { handling_office_code: 'MN1', master_shipper_code: '1ARSPDMNL' },
    { handling_office_code: 'MN2', master_shipper_code: '1FTLOGMNL' },
    { handling_office_code: 'MNL', master_shipper_code: '1EAGLEMNL' },
    { handling_office_code: 'CE2', master_shipper_code: '1AIRSPCEB' },
    { handling_office_code: 'KGP', master_shipper_code: '1SEAGDKHI' },    
    { handling_office_code: 'DWC', master_shipper_code: '1MRLOGDXB' },
    { handling_office_code: 'PN2', master_shipper_code: '1MRFORPNH' },
];

//export const OIAPIURL = 'https://capi2.ocean-insights.com/sailingschedules/v2/ports/?s=';

export const GUID = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

export function checkTBCContainerNoFormatValid(container_no) {
    if (!CheckIsNullOrUndefined(container_no) && container_no.length >= 3 && container_no.length <= 6 && checkNormalCharactersOnly(container_no) && !checkWhiteSpace(container_no) && container_no.toLowerCase().startsWith('tbc-')) {
        return true;
    }

    return false;
};

export const ArrToSelectBox = (ArrInput) => {
    let returnObj;

    if (Array.isArray(ArrInput)) {
        //console.log("HIHI Arr");
        if (ArrInput.length === 1) {
            if (ArrInput[0] !== "" && ArrInput[0] !== undefined) {
                returnObj = {
                    key: ArrInput[0],
                    label: ArrInput[0]
                };
            }
        } else {
            returnObj = [];
            ArrInput.map(item => {
                if (item !== "" && item !== undefined) {
                    returnObj.push({
                        key: item,
                        label: item
                    });
                }
                return true;
            });
        }
    } else if (ArrInput !== "") {
        returnObj = {
            key: ArrInput,
            label: ArrInput
        };
    }

    return returnObj;
};

export const ArrToFilterList = (ArrInput) => {
    let returnArr = [];
    try {
        ArrInput.map(record => {
            returnArr.push({
                text: record,
                value: record
            });
            return true;
        });
    } catch (error) {
        console.log("Common:ArrToFilterList:::", error);
    }
    return returnArr;
};

export const MomentDateToString = (dtMoment) => {
    if (moment.isMoment(dtMoment)) {
        let strDate = dtMoment.format(DateFormat);
        //console.log('MomentDateToString', strDate);
        return strDate;
    }
    return null;
};

export const MomentDateTimeToString = (dtMoment) => {
    if (moment.isMoment(dtMoment)) {
        let strDateTime = dtMoment.format('YYYY-MM-DD[T]HH:mm:ss');
        //console.log('MomentDateTimeToString', strDateTime);
        return strDateTime;
    }
    return null;
};

export const MoneyFieldFilter = (NumberInput, OriginalValue, DecimalPlaces = 2) => {
    let numberString = NumberInput.toString();
    let returnString = OriginalValue;

    if ((numberString.match(/\./g) || []).length <= 1 && (numberString.match(/[^0-9|.-]/g) || []).length === 0) {

        returnString = numberString.indexOf('.') > -1 ?
            numberString.toString().substring(0, numberString.indexOf('.') + (DecimalPlaces + 1))
            :
            numberString;
    }

    return returnString;
};

export const DefaultPageSize = () => {
    return parseInt(localStorage.getItem('default_page_size')) || 10;
}


export const FallbackElements = <>
    <Skeleton active />
    <Skeleton active />
    <Skeleton active />
</>;

export const SetTitle = (title) => {
    const baseTitle = 'M+R';
    document.title = (title || '') === '' ? baseTitle : `${baseTitle} - ${title}`;
};

export const GetSectionNameFromUrl = (match) => {
    const { path } = match;
    let r = routingTable.filter(r => r.path === path);
    if (r.length) {
        return r[0].name;
    }
    return '';
}

export const GetSectionDetailsFromUrl = (match) => {
    const { path } = match;
    let r = routingTable.filter(r => r.path === path);
    if (r.length) {
        return r[0];
    }
    return '';
}

export const htmlDecode = (input) => {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

export const DownloadAJAXBlob = (file, file_name) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { //Edge Fix
        window.navigator.msSaveOrOpenBlob(file, file_name);
    } else {
        console.log("Download Come here")
        var a = document.createElement('a');
        const fileURL = URL.createObjectURL(file);
        a.href = fileURL;
        a.download = file_name;
        document.body.appendChild(a); //Firefox fix
        a.click();
        setTimeout(function () { //Firefox Fix
            document.body.removeChild(a); //Firefox Fix
            window.URL.revokeObjectURL(fileURL)
        }, 100);
    }
}

export const RoundUp2Decimal = (inputNumber, DecimalPlaces = 2) => {
    //Before local Invoice //return Math.round(parseFloat((inputNumber * Math.pow(10, DecimalPlaces)).toFixed(1))) / Math.pow(10, DecimalPlaces);
    //After local Invoice //return Math.round(parseFloat((inputNumber * Math.pow(10, DecimalPlaces)).toFixed(0))) / Math.pow(10, DecimalPlaces);
    //20201118 11397 * 6.705(exchange rate) = ROUND(76416.885) should = 76416.89 instead of 76416.88 
    /*** 20201127 Test Case
    console.log("Test 1 Calculation(290 / 1.06) = 273.58::", Common.RoundUp2Decimal(290 / 1.06));
    console.log("Test 2 Calculation(11397 * 6.705) = 76416.89::", Common.RoundUp2Decimal(11397 * 6.705));
    console.log("Test 3 Calculation(1100 / 1.06) = 1037.74::", Common.RoundUp2Decimal(1100 / 1.06));
    console.log("Test 4 Calculation(487.14 * 6.4584) = 3146.14::", Common.RoundUp2Decimal(487.14 * 6.4584));
    console.log("Test 5 Calculation(245.53 * 6.4754) = 1589.90::", Common.RoundUp2Decimal(245.53 * 6.4754));

    console.log("Test 6 Calculation(undefined) = NaN::", Common.RoundUp2Decimal(undefined)); --Kin Request
    console.log("Test 7 Calculation(-849.630) = -850::", Common.RoundUp2Decimal(-849.630,0));
    
    console.log("Test 8 Calculation((1.24*7.77016)) = 9.64", Common.RoundUp2Decimal(9.634998399999999, 2))
    ***/

    let inputNumberString = (inputNumber * 1).toFixed(DecimalPlaces + 5)
    let roundingDigit = parseInt(inputNumberString.substring(inputNumberString.length - 5, inputNumberString.length - 4))
    let returnNumber = parseFloat(inputNumberString.substring(0, inputNumberString.length - 5));

    if (roundingDigit >= 5) {
        if (returnNumber > 0) {
            returnNumber += 1 / Math.pow(10, DecimalPlaces)
        } else {
            returnNumber -= 1 / Math.pow(10, DecimalPlaces)
        }
    }

    return returnNumber;
    //return Math.round(parseFloat((inputNumber * Math.pow(10, DecimalPlaces)).toFixed(DecimalPlaces))) / Math.pow(10, DecimalPlaces);
}

export const RoundDecimal = (inputNumber, DecimalPlaces = 2, Method = 'ROUND') => {
    //Before local Invoice //return Math.round(parseFloat((inputNumber * Math.pow(10, DecimalPlaces)).toFixed(1))) / Math.pow(10, DecimalPlaces);
    //After local Invoice //return Math.round(parseFloat((inputNumber * Math.pow(10, DecimalPlaces)).toFixed(0))) / Math.pow(10, DecimalPlaces);
    //20201118 11397 * 6.705(exchange rate) = ROUND(76416.885) should = 76416.89 instead of 76416.88 
    /*** 20201127 Test Case
    console.log("Test 1 Calculation(290 / 1.06) = 273.58::", Common.RoundUp2Decimal(290 / 1.06));
    console.log("Test 2 Calculation(11397 * 6.705) = 76416.89::", Common.RoundUp2Decimal(11397 * 6.705));
    console.log("Test 3 Calculation(1100 / 1.06) = 1037.74::", Common.RoundUp2Decimal(1100 / 1.06));
    console.log("Test 4 Calculation(487.14 * 6.4584) = 3146.14::", Common.RoundUp2Decimal(487.14 * 6.4584));
    console.log("Test 5 Calculation(245.53 * 6.4754) = 1589.90::", Common.RoundUp2Decimal(245.53 * 6.4754));

    console.log("Test 6 Calculation(undefined) = NaN::", Common.RoundUp2Decimal(undefined)); --Kin Request
    console.log("Test 7 Calculation(-849.630) = -850::", Common.RoundUp2Decimal(-849.630,0));
    ***/

    let inputNumberString = (inputNumber * 1).toFixed(DecimalPlaces + 3)
    let roundingDigit = parseInt(inputNumberString.substring(inputNumberString.length - 3, inputNumberString.length - 2))
    let returnNumber = parseFloat(inputNumberString.substring(0, inputNumberString.length - 3));

    if ((roundingDigit >= 5 && Method === 'ROUND')
        || Method === 'CEIL'
    ) {
        if (returnNumber > 0) {
            returnNumber += 1 / Math.pow(10, DecimalPlaces)
        } else {
            returnNumber -= 1 / Math.pow(10, DecimalPlaces)
        }
    }

    return returnNumber;
    //return Math.round(parseFloat((inputNumber * Math.pow(10, DecimalPlaces)).toFixed(DecimalPlaces))) / Math.pow(10, DecimalPlaces);
}

export const NumberFormatter = (inputNumber) => {
    let returnString;
    //20211007 #4805
    if (inputNumber === undefined) {
        returnString = ''
    } else {
        returnString = inputNumber.toString().replace('#', '');
    }
    //let negative = false;
    //if (returnString.charAt(0) === '-') {
    //    negative = true;
    //}
    if (returnString.indexOf('.') > -1) {
        let stringArr = returnString.split('.');
        returnString = stringArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + stringArr[1];
    } else {
        returnString = returnString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    //if (negative) {
    //    returnString = '-' + returnString
    //}

    return returnString;

}

export const NumberParser = (inputNumberString) => {
    return inputNumberString.toString().replace(/(,*)/g, '') + '#';
}
export const NumberOnChange = (inputNumberString) => {
    if (inputNumberString === '.') {
        inputNumberString = '0.'
    }
    return inputNumberString ? inputNumberString.toString().replace('#', '') : '0';
}

export const NumberParser_Antd4 = (inputNumberString) => {
    let returnString = inputNumberString.toString().replace(/(,*)/g, '');
    //returnString = returnString.replace(/\D/g, '');

    let negative = false;
    if (returnString.indexOf('-') > -1) {
        negative = true;
    }

    if (returnString.indexOf('.') > -1) {
        let stringArr = returnString.split('.');

        let frontNumber = stringArr[0].replace(/\D/g, '');
        if (frontNumber !== '0') {
            frontNumber = frontNumber.replace(/^0+/, '')
        }

        returnString = frontNumber + '.' + stringArr[1].replace(/\D/g, '');
    } else {
        returnString = returnString.replace(/^0+/, '').replace(/\D/g, '')
    }
    if (returnString === '.') {
        returnString = '0.'
    }

    if (negative) {
        returnString = '-' + returnString
    }

    return returnString ? returnString.toString().replace('#', '') : '0';
}

export const NumberOnBlur = (inputNumberString, DecimalPlaces = 2) => {
    let outputNumber = isNaN(parseFloat(NumberParser(inputNumberString))) ? 0 : parseFloat(NumberParser(inputNumberString));
    return outputNumber.toFixed(DecimalPlaces)
}

export const NumberOnBlur_Antd4 = (inputNumberString, min, max, DecimalPlaces = 2) => {
    let outputNumber = isNaN(parseFloat(NumberParser(inputNumberString))) ? 0 : parseFloat(NumberParser(inputNumberString));
    if (outputNumber < min) {
        outputNumber = min
    }
    if (outputNumber > max) {
        outputNumber = max
    }
    //return DecimalPlaces < 0 ? outputNumber.toString() : outputNumber.toFixed(DecimalPlaces);
    return outputNumber.toString();
}

export const dynamicSort = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

export const dynamicSort2Column = (propertyA, propertyB) => {
    return function (a, b) {
        if (a[propertyA] === b[propertyA]) {
            return a[propertyB] < b[propertyB] ? -1 : 1
        } else {
            return a[propertyA] < b[propertyA] ? -1 : 1
        }
    }
}

export const CheckIsNullOrUndefined = (input) => (input === null || input === undefined);

export const CheckIsEmptyString = (input) => (input === null || input === undefined || input === '');

// control characters and Unicode format marks (zero-width spaces, BOM, soft hyphen, bidi marks) that render as nothing
const invisibleCharsRegex = /[\u0000-\u001F\u007F-\u009F\u00AD\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/g;

export const RemoveInvisibleCharsAndTrim = (input) => (typeof input === 'string' ? input.replace(invisibleCharsRegex, '').trim() : input);

export const CheckIsEmptyArray = (input) => (input === null || input === undefined || !isArray(input) || input.length === 0);

export const CheckIsEmptyObject = (input) => (input === null || input === undefined || Object.keys(input).length === 0);

export const validateEmail = (email) => {
    var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

    if (email) email = email.toLowerCase();

    return re.test(email);
}

export const removeInvisibleChar = (val) => {
    const invisibleChar = /[\u200c\u200d\ufeff]/gu;

    // 1. Base case: Not an object or is null, handle string vs others
    if (val === null || typeof val !== 'object') {
        if (typeof val === 'string') {
            return val.replace(invisibleChar, '').trim();
        }
        return val;
    }

    // 2. Handle Arrays
    if (Array.isArray(val)) {
        return val.map(removeInvisibleChar);
    }

    // 3. Handle Objects (Recursive)
    for (const key in val) {
        // This ensures we go deep into 'isf', then 'seller', then 'zip'
        val[key] = removeInvisibleChar(val[key]);
    }
    return val;
}

export const showAjaxErrorMsg = (error) => {
    if (error.response && error.response.status === 404) {
        Message.warn(getText('msgNoRecordFound'), 10);
    }
    else if (error.response && error.response.data) {
        Message.error(`${error.response.data.Message}`, 10);
    }
    else {
        Message.error(`${error}`, 10);
    }
}

export const checkStrongPassword = (pw) => {
    let patten = /^(?=(.*\d))(?=.*[a-z])(?=.*[A-Z]).{8,}$/g;

    return patten.test(pw);
}

export function checkNormalCharactersOnly(text) {
    let englishReg = /^[~`!@#$%^&*()_+=[\]\\{}|;':",.\/<>?a-zA-Z0-9- ]+$|^$/;

    return englishReg.test(text);
}

export function replaceToUpperCase(text) {
    let englishReg = /[^~`!@#$%^&*()_+=[\]\\{}|;':",.\/<>?a-zA-Z0-9- \r\n]/gi;

    if (text) {
        return text.replace(englishReg, '').toUpperCase();
    }

    return '';
}

export function trimWhiteSpace(text) {
    let englishReg = /[\r\n\t\f\v]/gi;

    if (text) {
        return text.replace(englishReg, '').trim();
    }

    return '';
}

export function checkWhiteSpace(text) {
    let noWhiteSpaceReg = /^[^\r\n\t\f\v\s]*$/;

    return !noWhiteSpaceReg.test(text);
}

export function taxIDReg(tax_type) {
    switch (tax_type?.toUpperCase()??"")
    {
        case "EIN":
            return /^\d{2}-\d{7}([A-Z0-9]{2})?$/;
        case "CBP":
            return /^\d{6}-\d{5}$/;
        case "SSN":
            return /^\d{3}-\d{2}-\d{4}$/;
        case "PASSPORT":
            return /^[A-z0-9]{1,12}$/;
        default:
            return null;
    }
}

export function validateTaxID(text, detail_tax_type) {
    const pattern = taxIDReg(detail_tax_type);
    if (pattern) {
        return pattern.test(text);
    } else {
        return true;
    }
};

export function validateUSAssignedID(text, isf_cns_num_type) {
    return validateTaxID(text, isf_cns_num_type);
};

export function formatCnsIorValue(value, type) {
    let formattedValue = '';

    // Remove existing hyphens from the input value
    value = value.replace(/-/g, '');

    // Add hyphens based on the ID type and expected format
    if (type === 'EIN') {
        if (value.length > 2) {
            formattedValue += value.substr(0, 2) + '-';
            value = value.substr(2);
        }
    }
    else if (type === 'CBP') {
        if (value.length > 6) {
            formattedValue += value.substr(0, 6) + '-';
            value = value.substr(6);
        }
    }
    else if (type === 'SSN') {
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }
        if (value.length > 2 && formattedValue.includes('-')) {
            formattedValue += value.substr(0, 2) + '-';
            value = value.substr(2);
        }
    }

    // Combine the formatted value with the remaining input value
    formattedValue += value;

    return formattedValue || value;
}


export function getOMSETDRange(po) {
    let etdRange = { omsETDRangeFrom: null, omsETDRangeTo: null };
    if (isArray(po)) {
        po.forEach(po => {
            if (CheckIsNullOrUndefined(etdRange.omsETDRangeFrom)) {
                etdRange.omsETDRangeFrom = po.earliest_ship_date;
            }
            else {
                if (!CheckIsEmptyString(po.earliest_ship_date) && moment(po.earliest_ship_date).isValid() && moment(po.earliest_ship_date).isAfter(etdRange.omsETDRangeFrom)) {
                    etdRange.omsETDRangeFrom = po.earliest_ship_date;
                }
            }

            if (CheckIsNullOrUndefined(etdRange.omsETDRangeTo)) {
                etdRange.omsETDRangeTo = po.est_ship_date;
            }
            else {
                if (!CheckIsEmptyString(po.est_ship_date) && moment(po.est_ship_date).isValid() && moment(po.est_ship_date).isBefore(etdRange.omsETDRangeTo)) {
                    etdRange.omsETDRangeTo = po.est_ship_date;
                }
            }
        });

        if (CheckIsEmptyString(etdRange.omsETDRangeFrom) || CheckIsEmptyString(etdRange.omsETDRangeTo) || (moment(etdRange.omsETDRangeFrom).isValid() && moment(etdRange.omsETDRangeTo).isValid() && moment(etdRange.omsETDRangeFrom).isAfter(etdRange.omsETDRangeTo))) {
            etdRange = { omsETDRangeFrom: null, omsETDRangeTo: null };
        }
    }

    return etdRange;
}


export const ExcelDateToJSDate = (serial) => {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;

    var total_seconds = Math.floor(86400 * fractional_day);

    var seconds = total_seconds % 60;

    total_seconds -= seconds;

    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
}

export const getBrowser = () => {
    let returnBrowser = '';

    if (window.chrome !== undefined) {
        returnBrowser = 'chrome';
    } else if (window.navigator.userAgent.indexOf("Edg") > -1) {
        returnBrowser = 'edge';
    } else if (window.navigator.userAgent.indexOf("Mozilla") > -1) {
        returnBrowser = 'firefox';
    }
    //console.log(window.chrome, window.navigator, returnBrowser)
    
    return returnBrowser
}

export const countHTMLtextSizeInMB = text => {
    let count = 0;
    if (navigator.platform.indexOf('Win') === 0)
    {
        count = calculateHTMLTextSize(text, { lineBreaks: 2 });
    }
    else 
    {
        count = calculateHTMLTextSize(text);
    }
    return count > 0 ? (Math.round((count/1024/1024)*100)/100) : 0;
}

const calculateHTMLTextSize = (text, options) => {
    let crlf = /(\r?\n|\r)/g
    let whitespace = /(\r?\n|\r|\s+)/g;

    // Set option defaults
    options = options || {};
    options.lineBreaks = options.lineBreaks || 1;
    options.ignoreWhitespace = options.ignoreWhitespace || false;
    
    let length = text.length;
    let nonAscii = length - text.replace(/[\u0100-\uFFFF]/g, '').length;
    let lineBreaks = length - text.replace(crlf, '').length; 
    
    if (options.ignoreWhitespace) {
        // Strip whitespace
        text = text.replace(whitespace, '');
        
        return text.length + nonAscii;
    }
    else {
        return length + nonAscii + Math.max(0, options.lineBreaks * (lineBreaks - 1));
    }
}

export const getBraftEditorPlainText = text => {
    var plainText = text;

    //replace all new line character to space for plain text
    ["p", "div"].forEach(newLineTag => {
        ["<", "</"].forEach(p => {
            var prefix = `${p}${newLineTag}`;
            var prefixIndex = plainText.indexOf(prefix);
            var suffixIndex = prefixIndex + plainText.substring(prefixIndex).indexOf(">") + 1;
            while (prefixIndex > -1 && suffixIndex > (prefixIndex + 1)) {
                plainText = plainText.replace(plainText.substring(prefixIndex, suffixIndex), "</br>");

                prefixIndex = plainText.indexOf(prefix);
                suffixIndex = prefixIndex + plainText.substring(prefixIndex).indexOf(">") + 1;
            }
        });
    });
    while (plainText.indexOf("</br></br>") > -1) {
        plainText = plainText.replace("</br></br>", "</br>");
    }
    while (plainText.indexOf("</br>") > -1) {
        plainText = plainText.replace("</br>", " ");
    }

    while (plainText.indexOf("<") > -1 && plainText.indexOf(">") > -1) {
        plainText = plainText.replace(plainText.substring(plainText.indexOf("<"), plainText.indexOf(">") + 1), "");
    }
    plainText = decodeHtml(plainText.trim());
    
    return plainText;
}

export const formResetFields = (form, fields) => {
    form && form.resetFields && form.resetFields(fields);
}

export const formSetFieldsValue = (form, values) => {
    form && form.setFieldsValue && form.setFieldsValue(values);
}

export const formGetFieldValue = (form, field) => {
    return form && form.getFieldValue && form.getFieldValue(field);
}

export const formSetFields = (form, fields) => {
    form && form.setFields && form.setFields(fields);
}

export const formValidateFields = (form, fields) => {
    form && form.validateFields && form.validateFields(fields);
}

export const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

export const isENSParticipant = (countryCode, cityCode) => {
    return ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI",
        "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU",
        "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE",
        "CH", "NO", "GF", "GP", "MQ", "RE" , "YT"
        ].includes((countryCode || '').toUpperCase()) ||
        ["GBBEL", "GBCLR", "GBLDY", "GBWPT", "GBLAR", "GBPTR"].includes((cityCode || '').toUpperCase());
}

// export const getEORIRegExp = (countryCode, cityCode, nullable) => {
//     if (isENSParticipant(countryCode, cityCode) &&
//             !["CH", "NO"].includes((countryCode || '').toUpperCase()) &&
//             !["GBBEL", "GBCLR", "GBLDY", "GBWPT", "GBLAR", "GBPTR"].includes((cityCode || '').toUpperCase()))
//         return nullable ? new RegExp(/^[A-Z]{2}[a-zA-Z0-9]{0,15}$|^$/) : new RegExp(/^[A-Z]{2}[a-zA-Z0-9]{0,15}$/);
//     else
//         return new RegExp(/^.{0,}$/);
// }

export const jobTypeMapping = {
    c: 'Cancelled',
    i: 'Inbound',
    o: 'Outbound'
};

export const jobStatusMapping = {
    opn: 'OPEN',
    del: 'DELETED'
};

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function getDisabledPOLETDInitial (currentDate) {
    let startDate = moment().add(1, 'days');
    let endDate = moment().add(3, 'months').endOf("month");

    return !currentDate.isBetween(startDate, endDate, 'days', '[]');
}

export const defaultSailingScheduleSortBy = 'pol_etd,transit_time';
export const defaultRateSortBy = 'carrier_shortname,total_rate';

export function compareScheduleAttr(a, b, sortBy, checkedRateContainerSizes) {
    sortBy = sortBy.split(',');
    let field = sortBy.shift();
    if (field === 'total_rate') {
        let a_min_total_rate = Math.min(...[].concat(a.rates?.flatMap((r) => r.rate_containers)?.filter(c => checkedRateContainerSizes.includes(c.container_size))?.flatMap((c) => c.total_rate)));
        let b_min_total_rate = Math.min(...[].concat(b.rates?.flatMap((r) => r.rate_containers)?.filter(c => checkedRateContainerSizes.includes(c.container_size))?.flatMap((c) => c.total_rate)));
        if (a_min_total_rate > b_min_total_rate) return 1;
        if (a_min_total_rate < b_min_total_rate) return -1;
    }
    else {
        if (a[field] > b[field]) return 1;
        if (a[field] < b[field]) return -1;
    }
    if (sortBy.length > 0) return compareScheduleAttr(a, b, sortBy.join(','), checkedRateContainerSizes);
    return 0;
}

export function compareRateAttr(a, b, sortBy, checkedRateContainerSizes) {
    sortBy = sortBy.split(',');
    let field = sortBy.shift();
    if (field === 'total_rate') {
        let a_min_total_rate = Math.min(...[].concat(a?.rate_containers?.filter(c => checkedRateContainerSizes.includes(c.container_size))?.flatMap((c) => c.total_rate)));
        let b_min_total_rate = Math.min(...[].concat(b?.rate_containers?.filter(c => checkedRateContainerSizes.includes(c.container_size))?.flatMap((c) => c.total_rate)));
        if (a_min_total_rate > b_min_total_rate) return 1;
        if (a_min_total_rate < b_min_total_rate) return -1;
    }
    else {
        if (a[field] > b[field]) return 1;
        if (a[field] < b[field]) return -1;
    }
    if (sortBy.length > 0) return compareRateAttr(a, b, sortBy.join(','), checkedRateContainerSizes);
    return 0;
}

export function useStateCallback(initialState) {
    const [state, setState] = useState({
        state: initialState,
        cbID: undefined
    });
    const cbRef = useRef([]);

    const setStateCallback = useCallback((state, cb) => {
        var cbID = GUID();
        var cb_obj = {
            cb,
            cbID
        }
        cb && typeof cb === 'function' && cbRef.current.push(cb_obj);
        setState(prevState => ({
            state: { ...prevState.state, ...state },
            cbID
        }));
    }, []);

    useEffect(() => {
        if (cbRef.current) {
            cbRef.current.length > 0 && cbRef.current.find(cb => cb.cbID === state.cbID)?.cb(state.state);
            cbRef.current = cbRef.current.filter(cb => cb.cbID !== state.cbID);
        }
    }, [state]);

    return [state.state, setStateCallback];
}

export function onCopyRateJsonClick(item) {
    navigator.clipboard.writeText(JSON.stringify(item));
    Message.info('Copied');
}

export const wordWrap = (text, maxLineLength) => 
{
    const breakChars = [' ']; //[' ', '-', '/', '\\', '.', ',', ':', ';']; -- to be the same with the logic in C#

    const escapeRegax = ch => ch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`([${breakChars.map(escapeRegax).join('')}])`, 'g');

    const tokens = (text ?? '').replace(/\r\n/g, '\n').split(regex).filter(x => x !== '');

    const result = [];
    let line = '';
    for (let token of tokens)
    {
        const testLine = line + token;
        if (testLine.length > maxLineLength && line.length > 0)
        {
            result.push(line);
            line = token;
        }
        else
        {
            line = testLine;
        }
    }

    if (line)
        result.push(line);

    return result.join('\n');
}

export const countLineLength = (text, maxLineLength) => 
{
    if (maxLineLength > 0)
        text = wordWrap(text, maxLineLength);
    
    return (text??"").split('\n').length;
}